import React, { useContext, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import ReusableTabs from 'components/commom/Tab';
import ReusableButton from 'components/commom/Button';
import { getTermsPrivacyDataCallApi } from 'store/getTerms&Privacy/action';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { postTermsPrivacyDataCallApi } from 'store/postTerms&Privacy/action';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CommonToast from 'components/commom/CommonToast';
import DoctorEarning from './DoctorEarning';
import ImpressionsClicksList from './Impressions';

const Setting = () => {
  const { locale } = useContext(LocaleContext);
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = CommonToast();
  const [tab, setTab] = useState(1);

  const [formData, setFormData] = useState({
    termValue: '',
    privacyValue: '',
  });

  const modules = {
    toolbar: [
      [{ header: [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'image'],
      ['clean'],
    ],
  };

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'align',
    'link',
    'image',
  ];

  const loading = useSelector(
    (state) => state?.postTermsPrivacyDataReducer?.loading
  );

  const tabData = [
    { label: intl.formatMessage({ id: 'Terms and Conditions' }) },
    { label: intl.formatMessage({ id: 'Privacy Policy' }) },
    { label: intl.formatMessage({ id: `Doctor's Earning` }) },
    { label: intl.formatMessage({ id: `Impressions/Clicks` }) },
  ];

  const handleTabChange = (val) => {
    setTab(val);
  };

  useEffect(() => {
    getTermsPrivacyData();
  }, [tab]);

  const getTermsPrivacyData = () => {
    const slug = tab === 1 ? 'terms-and-condition' : 'privacy-policy';
    const external = {
      slug,
      run: true,
      handleFunction: (res) => handleSuccess(res),
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getTermsPrivacyDataCallApi(external));
  };

  const handleSuccess = (res) => {
    setFormData((prev) => ({
      ...prev,
      termValue: res?.data?.content,
      privacyValue: res?.data?.content,
    }));
  };

  const handleDescription = (fieldName, content) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: content,
    }));
  };

  const handleSendTermsPrivacyData = () => {
    if (tab === 1 && isHtmlContentEmpty(formData?.termValue)) {
      return showToast('Terms and Conditions should not be empty.', 'error');
    } else if (tab === 2 && isHtmlContentEmpty(formData?.privacyValue)) {
      return showToast('Privacy Policy should not be empty.', 'error');
    }

    let body = {
      slug: tab === 1 ? 'terms-and-condition' : 'privacy-policy',
      content: tab === 1 ? formData?.termValue : formData?.privacyValue,
    };
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        getTermsPrivacyData();
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(postTermsPrivacyDataCallApi(external, body));
  };

  const isHtmlContentEmpty = (html) => {
    const stripped = html?.replace(/<[^>]*>/g, '').trim();
    return !stripped;
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
            <FormattedMessage id="Settings" />
          </h2>

          <Row className="m-0 p-0">
            <Col md={12} lg={6} className="p-0">
              <div className="pt-24">
                <ReusableTabs
                  tabs={tabData}
                  defaultTab={tab}
                  currentTab={(val) => handleTabChange(val)}
                  background={'#864629'}
                  color={'#FFFFFF'}
                  tabColor={'#A2A2A2'}
                  completeColor={'#FFFFFF'}
                  boxShadow={'0px 3px 16px 0px #00000014'}
                />
              </div>
            </Col>
          </Row>
          {tab === 1 && (
            <Row className="m-0 p-0 mt-3 bc-FFFFFF">
              <Col md={12} lg={12} className="p-0">
                <ReactQuill
                  theme="snow"
                  value={formData?.termValue}
                  onChange={(content) =>
                    handleDescription('termValue', content)
                  }
                  modules={modules}
                  formats={formats}
                  placeholder={intl.formatMessage({
                    id: 'Write Terms and Conditions ....',
                  })}
                />
              </Col>
            </Row>
          )}

          {tab === 2 && (
            <Row className="m-0 p-0 mt-3">
              <Col md={12} lg={12} className=" p-0 bc-FFFFFF">
                <ReactQuill
                  theme="snow"
                  value={formData?.privacyValue}
                  onChange={(content) =>
                    handleDescription('privacyValue', content)
                  }
                  modules={modules}
                  formats={formats}
                  placeholder={intl.formatMessage({
                    id: 'Write Privacy Policy ....',
                  })}
                />
              </Col>
            </Row>
          )}

          {tab === 3 && (
            <div>
              {/* <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
                <FormattedMessage id="Doctor's Earning" />
              </h2> */}
              <DoctorEarning />
            </div>
          )}

          {tab === 4 && (
            <div>
              <ImpressionsClicksList />
            </div>
          )}

          {tab !== 3 && tab !== 4 && (
            <Col sm={12} md={12} className="p-0 d-flex justify-content-end">
              <div className="mt-3">
                <ReusableButton
                  fullWidth={true}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="16px"
                  fontWeight="500"
                  padding="12px 50px"
                  height="44px"
                  bgColor="#375241"
                  brColor="#375241"
                  fontFamily="outfit_regular"
                  onClick={() => {
                    !loading && handleSendTermsPrivacyData();
                  }}
                  loading={loading}
                >
                  <FormattedMessage id="Save" />
                </ReusableButton>
              </div>
            </Col>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default Setting;
